export default __webpack_public_path__ + "static/media/file-icon.a86b93e8.svg";